// eslint-disable-next-line import/no-unresolved
import KeenSlider from 'https://cdn.skypack.dev/pin/keen-slider@v6.7.0-LKl0HtBlpKLwpmTQiIJc/mode=imports,min/optimized/keen-slider.js'
const { setInitialised, useArrows } = window.BAO.Carousel.plugins

class WhatsInside extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.initialiseInfoCarousel()
  }

  setupListeners () {
    super.setupListeners()

    this.openDoor = this.openDoor.bind(this)

    this.els.open.elements.forEach(openEl => {
      this.listeners.add(openEl, 'click', this.openDoor)
    })
  }

  openDoor (e) {
    const block = e.target.closest(this.els.block.selector)
    block.ariaSelected = true
  }

  initialiseInfoCarousel () {
    if (this.els.slider.element) {
      return new KeenSlider(
        this.els.slider.element,
        {
          slides: {
            perView: 'auto',
            spacing: 10,
            origin: 'center',
          },
          breakpoints: {
            '(min-width: 901px)': {
              slides: {
                perView: 'auto',
                spacing: 10,
                origin: 'auto',
              },
            },
          },
        },
        [
          carousel => {
            carousel.on('animationStarted', () => {
              const nextActiveIndex = carousel.track.absToRel(
                carousel.animator.targetIdx || 0,
              )

              carousel.slides.forEach((slide, index) => {
                slide.setAttribute('aria-current', index === nextActiveIndex)
              })

              this.activeIndex = nextActiveIndex
            })
          },
          setInitialised(),
          useArrows({
            next: this.els.next.element,
            previous: this.els.previous.element,
          }),
        ],
      )
    }
  }
}

if (!customElements.get('whats-inside')) {
  customElements.define('whats-inside', WhatsInside)
}
